import { AnalyzeConstants } from '../../_constants/Analyze/analyze.constants';
import { competencySevice } from '../../_services/Analyze/competency.service';

export const competencyAction = {
    competencyDataAction
}


function competencyDataAction(data,callBack) {
    return dispatch => {
        dispatch(request());
        competencySevice.competencyData(data)
            .then(
                res => {
                    dispatch(success(res));
                    callBack != undefined ? callBack(res) : null
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: AnalyzeConstants.REQUEST_COMPETENCY } }
    function success(res) { return { type: AnalyzeConstants.RECEIVE_COMPETENCY, res } }
    function failure(error) { return { type: AnalyzeConstants.ERROR_COMPETENCY, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/Analyze/competency.action.js